<div class="spinner-container">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
